import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { InputGroup, InputGroupText, Input, Spinner, Badge, Card, Row, Col } from "reactstrap";
import { listenToThreadsLive, loadOlderThreads, threadsReset } from "../../redux/Messages/ThreadsAction";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { clearTitleAlert } from "../../util/TitleAlerts";
import { avatarColors } from "util/DataList";
import {  getUserDataByEmails } from "redux/Messages/UsersPrepTalkAction";
function ThreadsList({
  meEmail, presenceMap,
  threadsDesc, loading, error, hasMoreOlder, loadingOlder,
  startLive, loadOlder, reset, onSelectThread, userDetails
}) {
  const [q, setQ] = useState("");
  const listRef = useRef(null);
  const sentinelRef = useRef(null);

  // useEffect(() => { const unsub = startLive({ meEmail }); return () => { unsub && unsub(); reset(); }; }, [meEmail, startLive, reset]);

  const isAdmin = userDetails?.admin === true;
  const [viewMode, setViewMode] = useState("mine");

  useEffect(() => {
    const unsub = startLive({ meEmail, isAdmin, viewMode });
    return () => { unsub && unsub(); reset(); };
  }, [meEmail, startLive, reset, isAdmin, viewMode]);


  const threadsAsc = useMemo(() => (threadsDesc || []), [threadsDesc]);

  const filteredThreads = useMemo(() => {
    if (!isAdmin) return threadsAsc;

    if (viewMode === "mine") {
      return threadsAsc.filter(t => (t.participantsEmails || []).includes(meEmail));
    } else {
      return threadsAsc.filter(t => !(t.participantsEmails || []).includes(meEmail));
    }
  }, [threadsAsc, isAdmin, viewMode, meEmail]);


  // const rows = useMemo(() => {
  //   const qq = q.toLowerCase();
  //   return threadsAsc.map(t => {
  //     const isGroup = !!t.isGroup;
  //     const title = isGroup ? (t.name || "Group") : (t.participantsEmails || []).find(e => e !== meEmail) || "";
  //     const online = !isGroup && !!presenceMap[title]?.online;
  //     const last = t.lastMessage || "";
  //     const match = !qq || title.toLowerCase().includes(qq) || last.toLowerCase().includes(qq);
  //     return { id: t.id, isGroup, name: t.name, participantsEmails: t.participantsEmails || [], title, online, last, matches: match };
  //   }).filter(r => r.matches);
  // }, [threadsAsc, q, meEmail, presenceMap]);

    


  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting && hasMoreOlder && !loadingOlder) loadOlder(); });
    }, { root: listRef.current, rootMargin:"200px", threshold:0 });
    if (sentinelRef.current) obs.observe(sentinelRef.current);
    return () => obs.disconnect();
  }, [hasMoreOlder, loadingOlder, loadOlder]);


  const [readMap, setReadMap] = useState({});


  const [threadClicked, setThreadClicked] = useState(0);

  useEffect(() => {
    let alive = true;
   
    (async () => {
      const entries = await Promise.all((threadsDesc || []).map(async t => {
        const d = await getDoc(doc(db, "threads", t.id, "reads", (meEmail || "").toLowerCase()));
       
        const ms = d.exists() ? (d.data().lastReadAt?.toMillis?.() || d.data().lastReadAt || 0) : 0;
        return [t.id, ms];
      }));
      if (alive) setReadMap(Object.fromEntries(entries));
    })();
    return () => { alive = false; };
  }, [threadsDesc, meEmail, threadClicked]);


 function timeAgo(ms) {
  const diff = Date.now() - ms;

  const sec = Math.floor(diff / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);
  const week = Math.floor(day / 7);
  const month = Math.floor(day / 30); // rough estimate
  const year = Math.floor(day / 365); // rough estimate

  if (sec < 60) return "now";
  if (min < 60) return `${min}m`;
  if (hr < 24) return `${hr}h`;
  if (day < 7) return `${day}d`;
  if (week < 5) return `${week}w`;
  if (month < 12) return `${month}mo`;
  return `${year}y`;
}

  const [tick, setTick] = useState(0);

  const rows = useMemo(() => {
      const qq = q.toLowerCase();
      return filteredThreads.map(t => {
        const isGroup = !!t.isGroup;
        const title = isGroup ? (t.name || "Group") : (t.participantsEmails || []).find(e => e !== meEmail) || "";
        const online = !isGroup && !!presenceMap[title]?.online;
        const last = t.lastMessage || "";
        const lastAtMs = t.lastAt?.toMillis?.() || t.lastAt || 0;
        const lastReadMs = readMap[t.id] ||  0;
        const unread = lastAtMs > lastReadMs;
        const match = !qq || title.toLowerCase().includes(qq) || last.toLowerCase().includes(qq);

        const lastAgo = timeAgo(lastAtMs);

          return { id: t.id, isGroup, name: t.name, participantsEmails: t.participantsEmails || [], title, online, last, matches: match, unread, lastAgo };
        }).filter(r => r.matches);
  }, [filteredThreads, q, meEmail, presenceMap, readMap, tick]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick(t => t + 1);
    }, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const anyUnread = rows.some(r => r.unread);
    if (!anyUnread) clearTitleAlert();
  }, [rows]);

  

  function shuffle(array) {
    let arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }


  const shuffledColors = useMemo(() => shuffle(avatarColors), []);


  // const [profilePictures, setProfilePictures] = useState({}); // { email: displayName }
  



  const [studentData, setStudentData] = useState([]); // { email: displayName }
  
  useEffect(() => {
    let cancelled = false;

    async function loadNames() {

      let data = [];
      for (const m of filteredThreads) {
        if(!m.isGroup){
          const emails = (m.participantsEmails || []).filter(e => e !== meEmail);
          
          const result = await getUserDataByEmails(emails);
          
          data = [...data , ...result]
  
        }
      }

        
      if (!cancelled) setStudentData(data);
    }

    loadNames();
    return () => { cancelled = true; };
  }, [filteredThreads]);


  return (
    <Card className="d-flex flex-column h-100">
      <div className="p-2">
        <InputGroup><InputGroupText><i class="fas fa-search text-primary font-weight-bolder text-lg"></i></InputGroupText><Input placeholder="Search chats…" className="pl-2" value={q} onChange={e=>setQ(e.target.value)} /></InputGroup>
        {error && <div className="text-danger small mt-2">{error}</div>}
        {isAdmin && (
          <Row className="mx-0 w-100 my-2">
            <Col className="p-1">
              <button
                className={`btn btn-sm w-100 ${viewMode === "mine" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setViewMode("mine")}
              >
                My Threads
              </button>
            </Col>
            <Col className="p-1">
              <button
                className={`btn btn-sm w-100 ${viewMode === "others" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setViewMode("others")}
              >
                Other Threads
              </button>
            </Col>
          </Row>
        )}


      </div>
      <div ref={listRef} className="overflow-auto" style={{height:'100%'}}>
        {loading && !filteredThreads.length && <div className="p-3 text-center text-muted"><Spinner size="sm" /> Loading…</div>}
        <div className="p-2">
          {rows.map((r, i) => { 

            const chatOwner = studentData.find(data => data.email == (r.participantsEmails.filter(email => email !== r.title)[0]));
            
            
            return (<button key={r.id} 
            className={`msgr-thread-item ${r.unread ? 'msgr-thread-unread' : ''}`} 
            onClick={() => {onSelectThread?.({ ...r, viewMode }); setThreadClicked(prev => prev + 1);}}>
              
              <div className="position-relative" style={{width:"44px", height:"44px"}}>
                { !studentData.find(data => data.email == r.title)?.profilePicture ? 
                <div className={"msgr-avatar "+(!r.isGroup ? (shuffledColors[i % shuffledColors.length]) : "bg-gradient-default")+" text-white"}><span>{(studentData.find(data => data.email == r.title)?.name || r.title ||"?").slice(0,1).toUpperCase()}</span>
                
                </div>
                :
              <img 
                    src={"https://storage.googleapis.com/pre-dental-tracker.appspot.com/profile-picture/" + studentData.find(data => data.email == r.title)?.profilePicture}
                    className="msgr-avatar border border-dark" 
                    alt="..." 
                    style={{
                        objectFit:"cover"
                    }}
                /> }

              
                
                {!r.isGroup && <span className={`position-absolute bottom-0 end-0 fas fa-circle msgr-dot  ${r.online ? 'text-success':'text-gray'}`} />}

                {r.isGroup && <span className='position-absolute bottom-0 end-0 msgr-dot2 border-0 fas fa-user-friends text-info'/>}

              </div>

              
              <div className="min-w-0 ml-1">
                <div className="d-flex align-items-center ">
                  <div className="min-w-0" style={{width:"95%"}}>
                    
                    <div className=" text-truncate text-sm font-weight-bolder pr-2">{r.isGroup ? (r.name || "Group") : (studentData.find(data => data.email == r.title)?.name || r.title)}</div>
                      {/* {!r.isGroup && r.online && <Badge color="success" pill>Online</Badge>} */}
                      {/* {r.isGroup && <Badge color="info" pill>Group</Badge>} */}

                    <div className="d-flex align-items-center text-capitalize">
                      
                      <div className="text-muted small text-truncate" >{r.last || <em>No messages yet</em>}</div>
                      
                        <>&nbsp;·<Badge color={r.unread ? "warning" : "light"} className="text-lowercase font-weight-bolder ml-1" style={{padding:5}} pill>{r.lastAgo}</Badge></>
                        

                    </div>
                    {!r.isGroup && viewMode == "others" && <div className="text-xs font-weight-bold"><Badge color={chatOwner?.coach ? "info" : "warning"} className="text-capitalize  ml-1" style={{padding:5}} pill>{chatOwner?.coach ? "Coach" : "Student"}</Badge> : {chatOwner?.name || chatOwner?.email || ""}</div>}
                  </div>
                  {r.unread && <div className="d-flex align-items-center" >
                      <i class="fas fa-circle text-xs text-warning"></i>
                      </div>}
                </div>
              </div>
              
            </button>
          )})}
          <div ref={sentinelRef} />
          {loadingOlder && <div className="p-2 text-center text-muted"><Spinner size="sm" /> Loading older…</div>}
          {!loading && rows.length === 0 && <div className="p-3 text-muted text-center">No chats found</div>}
        </div>
      </div>
    </Card>
  );
}

export default connect(
  state => ({
    userDetails: state.loginAuth.userDetails,
    threadsDesc: state.threads.threadsDesc,
    loading: state.threads.loading, error: state.threads.error,
    hasMoreOlder: state.threads.hasMoreOlder, loadingOlder: state.threads.loadingOlder
  }),
  d => ({
    startLive: (args)=>d(listenToThreadsLive(args)),
    loadOlder: ()=>d(loadOlderThreads()),
    reset: ()=>d(threadsReset())
  })
)(ThreadsList);
